import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import PiServerDeviceForm from './PiServerDeviceForm';
const message = defineMessages({
    objectName: 'Device',
});

const PiServerDeviceSavePage = () => {
    const translate = useTranslate();
    const params = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.kitplayDevice.getById,
            create: apiConfig.kitplayDevice.create,
            update: apiConfig.kitplayDevice.update,
        },
        options: {
            getListUrl: generatePath(routes.deviceTabsRestaurantListPage.path, { customerId: params.customerId }) + `?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}`,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    restaurantId,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    restaurantId,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.digibesShop),
                    path: routes.shopAccountListPage.path,
                },
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.RestaurantByCustomerListPage.path,{ customerId: params.customerId }),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.deviceTabsRestaurantListPage.path, {
                        customerId: params.customerId,
                    })}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <PiServerDeviceForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default PiServerDeviceSavePage;
